import React from 'react';

export const MasterAsfaltoIcon = (): React.ReactElement => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="211" height="133" viewBox="0 0 211 133" fill="none">
			<g clipPath="url(#clip0_6213_2153)">
				<path
					d="M139.911 11.3686L135.809 22.5865C130.413 20.3041 127.844 18.8185 123.202 14.4906L127.174 3.5957C131.859 7.79434 134.449 9.21542 139.89 11.3686H139.911Z"
					fill="#001e50"
				/>
				<path
					d="M169.098 16.6656L164.78 28.508C158.8 27.862 155.778 27.6252 149.928 26.5701C151.612 21.9624 152.454 19.6585 154.137 15.0508C160.031 15.9766 163.075 16.1489 169.098 16.6656Z"
					fill="#001e50"
				/>
				<path
					d="M198.263 21.9407C196.45 26.936 195.522 29.4336 193.708 34.4074C188.311 32.1251 185.44 31.4791 179.611 30.4241L184.058 18.2588C189.952 19.1846 192.845 19.766 198.263 21.9191V21.9407Z"
					fill="#001e50"
				/>
				<path
					d="M206.315 42.5246L201.652 55.3143C197.054 50.8572 194.506 49.307 189.152 46.8954L193.707 34.4287C199.104 36.711 201.673 38.1967 206.315 42.5246Z"
					fill="#001e50"
				/>
				<path
					d="M131.729 33.8045L127.628 45.0224C122.339 42.4817 119.813 40.8884 115.258 36.3022L119.23 25.4072C123.828 29.8642 126.376 31.4145 131.729 33.826V33.8045Z"
					fill="#001e50"
				/>
				<path
					d="M196.989 68.1041L192.326 80.8938C187.814 76.1784 185.31 74.5205 180.064 71.8506L184.619 59.3623C189.909 61.903 192.434 63.4964 196.989 68.0826V68.1041Z"
					fill="#001e50"
				/>
				<path
					d="M170.738 54.7546L166.291 66.9199C160.592 65.4988 157.634 65.0467 151.784 64.0347L156.102 52.1924C161.995 53.0752 164.974 53.4627 170.717 54.7546H170.738Z"
					fill="#001e50"
				/>
				<path
					d="M141.508 49.6302L137.298 61.1711C131.599 59.75 128.793 58.8887 123.547 56.2404C125.188 51.7618 126.008 49.501 127.649 45.0225C132.938 47.5632 135.766 48.3383 141.53 49.6302H141.508Z"
					fill="#001e50"
				/>
				<path
					d="M160.441 40.3496C158.714 45.0866 157.851 47.455 156.124 52.1919C150.23 51.3092 147.251 50.9216 141.509 49.6297L145.718 38.1104C151.504 39.2731 154.505 39.596 160.441 40.3496Z"
					fill="#001e50"
				/>
				<path
					d="M149.927 26.5703L145.717 38.0896C139.932 36.9269 137.082 36.1949 131.729 33.7833L135.83 22.5654C141.227 24.8478 144.098 25.5152 149.927 26.5488V26.5703Z"
					fill="#001e50"
				/>
				<path
					d="M179.611 30.4456L175.163 42.6109C169.378 41.4267 166.377 41.1252 160.419 40.3716L164.737 28.5293C170.738 29.1752 173.739 29.4121 179.589 30.4671L179.611 30.4456Z"
					fill="#001e50"
				/>
				<path
					d="M189.174 46.8952L184.619 59.3619C179.33 56.8212 176.502 56.046 170.76 54.7542L175.207 42.5889C180.992 43.7516 183.842 44.4836 189.196 46.8952H189.174Z"
					fill="#001e50"
				/>
				<path
					d="M127.345 -0.00577472L79.1025 132.266L81.1313 133.002L129.374 0.730292L127.345 -0.00577472Z"
					fill="#001e50"
				/>
				<path
					d="M71.0889 11.3686C72.7295 15.8471 73.5499 18.0864 75.1906 22.5865C80.5875 20.3041 83.1565 18.8185 87.7979 14.4906L83.8257 3.5957C79.1412 7.79434 76.5506 9.21542 71.1105 11.3686H71.0889Z"
					fill="#001e50"
				/>
				<path
					d="M41.9023 16.6656C43.6294 21.4026 44.4929 23.771 46.2199 28.508C52.1998 27.862 55.2221 27.6252 61.0724 26.5701C59.3885 21.9624 58.5466 19.6585 56.8628 15.0508C50.9693 15.9766 47.9254 16.1489 41.9023 16.6656Z"
					fill="#001e50"
				/>
				<path
					d="M12.7148 21.9407C14.5282 26.936 15.4565 29.4336 17.2699 34.4074C22.6669 32.1251 25.538 31.4791 31.3668 30.4241L26.9197 18.2588C21.0262 19.1846 18.1334 19.766 12.7148 21.9191V21.9407Z"
					fill="#001e50"
				/>
				<path
					d="M4.66309 42.5246C6.51964 47.649 7.46951 50.1898 9.32607 55.3143C13.9243 50.8572 16.4717 49.307 21.8255 46.8954C20.0121 41.9001 19.0838 39.4025 17.2704 34.4287C11.8734 36.711 9.30448 38.1967 4.66309 42.5246Z"
					fill="#001e50"
				/>
				<path
					d="M79.2705 33.8045L83.3722 45.0224C88.6612 42.4817 91.187 40.8884 95.7421 36.3022L91.7699 25.4072C87.1717 29.8642 84.6243 31.4145 79.2705 33.826V33.8045Z"
					fill="#001e50"
				/>
				<path
					d="M14.0107 68.1041L18.6737 80.8938C23.1856 76.1784 25.6898 74.5205 30.9356 71.8506L26.3806 59.3623C21.0916 61.903 18.5658 63.4964 14.0107 68.0826V68.1041Z"
					fill="#001e50"
				/>
				<path
					d="M40.2402 54.7546L44.6873 66.9199C50.3865 65.4988 53.3441 65.0467 59.1944 64.0347L54.8768 52.1924C48.9833 53.0752 46.0042 53.4627 40.2618 54.7546H40.2402Z"
					fill="#001e50"
				/>
				<path
					d="M69.4913 49.6302C71.1752 54.2379 72.0171 56.5418 73.701 61.1711C79.4002 59.75 82.2066 58.8887 87.4524 56.2404C85.8118 51.7618 84.9914 49.501 83.3507 45.0225C78.0617 47.5632 75.2337 48.3383 69.4697 49.6302H69.4913Z"
					fill="#001e50"
				/>
				<path
					d="M50.5371 40.3496C52.2641 45.0866 53.1277 47.455 54.8547 52.1919C60.7482 51.3092 63.7273 50.9216 69.4697 49.6297L65.26 38.1104C59.4745 39.2731 56.4738 39.596 50.5371 40.3496Z"
					fill="#001e50"
				/>
				<path
					d="M61.0723 26.5703C62.7561 31.178 63.598 33.4819 65.2819 38.0896C71.0675 36.9269 73.9171 36.1949 79.2709 33.7833L75.1692 22.5654C69.7722 24.8478 66.901 25.5152 61.0723 26.5488V26.5703Z"
					fill="#001e50"
				/>
				<path
					d="M31.3672 30.4456L35.8143 42.6109C41.5998 41.4267 44.6006 41.1252 50.5588 40.3716L46.2412 28.5293C40.2398 29.1752 37.2391 29.4121 31.3888 30.4671L31.3672 30.4456Z"
					fill="#001e50"
				/>
				<path
					d="M21.8253 46.8952L26.3803 59.3619C31.6694 56.8212 34.4974 56.046 40.2398 54.7542L35.7927 42.5889C30.0071 43.7516 27.1575 44.4836 21.8037 46.8952H21.8253Z"
					fill="#001e50"
				/>
				<path
					d="M83.636 0.00967347L81.6074 0.746094L129.873 133.009L131.902 132.273L83.636 0.00967347Z"
					fill="#001e50"
				/>
			</g>
			<defs>
				<clipPath id="clip0_6213_2153">
					<rect width="211" height="133" fill="#001e50" />
				</clipPath>
			</defs>
		</svg>
	);
};
